var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size || 40}},[(_vm.idProfessional)?_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"cover"},attrs:{"src":_vm.avatarUrl}}):_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("mdi-account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }